<template lang="pug">
.mapper(:class="'color_' + removeHashtag(color)" )
  .layout.row.title(:class="keys.length ? '' : 'only-title'")
    .flex.xs12.asu-title(:style="getBackgroundColorPropertyStyle(color)" v-if="title") {{ title }}
  template(v-for="key in keys")
    .layout.row
      .flex.xs4.key(:class="key", :style="getBackgroundColorPropertyStyle(color)") {{getTitle(key)}}
      .flex.xs8.value(:class="key" v-if="!isObjectOrArray(obj[key])" v-html="obj[key]")
      .flex.xs8.value(:class="key" v-else-if="isLink(obj[key])")
        router-link(:to="obj[key].link" @click.native="$event.stopImmediatePropagation()") {{obj[key].text}}
      .flex.xs8.value(:class="key" v-else) -

</template>

<script>
import colorPropertyMixin from '@/mixins/color-property.js'
import { addRules } from '@/utils/add-styles-in-header.js'
import { hasValue, getData } from '@/utils/object'

if (typeof Array.isArray === 'undefined') {
  Array.isArray = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]'
  }
}

export default {
  mixins: [ colorPropertyMixin ],
  props: {
    color: {
      type: String,
      default: '#0d2563'
    },
    obj: Object,
    title: String,
    titleMap: Object
  },
  mounted () {
    this.setKeys()
    this.addRulesForFichaTecnicaKey()
  },
  data: () => ({
    keys: [],
    titlesObj: {}
  }),
  methods: {
    hasValue,
    setKeys () {
      if (hasValue(this.obj)) {
        this.keys = Object.keys(this.obj)
        this.keys.forEach(key => {
          this.titlesObj[key] = hasValue(this.titleMap) ? this.titleMap[key] ? this.titleMap[key] : key : key
        })
      }
    },
    addRulesForFichaTecnicaKey () {
      const color = this.removeHashtag(this.color)
      const scope = this.getScopeName()
      const scopeSelector = scope ? '[' + scope + ']' : ''
      addRules('.color_' + color + ' .mapper .key' + scopeSelector + ':after', { 'border-left-color': this.color + '!important' })
    },
    getTitle (key) {
      return this.titlesObj[key]
    },
    isObjectOrArray (val) {
      return Array.isArray(val) || typeof val === 'object'
    },
    isLink (val) {
      return getData(val).link
    }
  },
  watch: {
    color () {
      this.setKeys()
      this.addRulesForFichaTecnicaKey()
    },
    obj () {
      this.setKeys()
    },
    title () {
      this.setKeys()
    },
    titleMap () {
      this.setKeys()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

$key-arrow-size = $f6px
$mapper-border-radius-size = $f5px

.mapper
  column-gap: 0
  line-height: 1
  .layout.row
    padding-bottom: $f4px
    padding-top: $f4px
    &.title
      padding-top: 0
    &.only-title
      padding-bottom: 0
  .asu-title,
  .key,
  .value
    display: flex
    align-items: center
    padding: $f10px
    white-space: normal
  .asu-title,
  .key
    color: white
  .key
    border-top-left-radius: $mapper-border-radius-size
    border-bottom-left-radius: $mapper-border-radius-size
    position: relative
    &:after
      content: ''
      display: inline-block
      height: 0
      width: 0
      border: $key-arrow-size outset transparent
      border-left-width: $key-arrow-size
      border-left-style: solid
      position: absolute
      left: 100%
  .asu-title
    border-radius: $mapper-border-radius-size
    font-size: 1.3rem
    font-weight: bold
  .value
    background-color: white
    border: $f1px solid #bbb
    border-top-right-radius: $mapper-border-radius-size
    border-bottom-right-radius: $mapper-border-radius-size
    white-space: pre-line
</style>
